export const getCardLabel = (key) => {
  switch (key) {
    case "new_raw_leads":
      return "Unassigned New Raw Leads";
    default:
      return key.replace(/_/g, " ");
  }
};

export const getCardValue = (key) => {
  switch (key) {
    case "unassigned_new_raw_leads":
      return "new_raw_leads";
    default:
      return key;
  }
};

export const keyMapping = {
  total_leads: "total_raw_leads",
  lead_added_today: "raw_lead_added_today",
  asigned_leads: "assigned_raw_leads",
  un_asigned_leads: "un_assigned_raw_leads",
};

export const extractConvertedTo = (arr) => {
  let converted_days_ago = [];

  arr?.length > 0 &&
    arr.forEach((item) => {
      const itemValue = item.value;
      converted_days_ago.push(itemValue);
    });

  return {
    converted_days_ago: converted_days_ago.join(", "),
  };
};

export const extractFollowupTimes = (arr) => {
  let followup_times = [];

  arr?.length > 0 &&
    arr.forEach((item) => {
      const itemValue = item.value;
      followup_times.push(itemValue);
    });

  return {
    followup_times: followup_times.join(", "),
  };
};
